import { generateSectionId } from '../helpers/layout-helpers';
import React from 'react';
// import { AppContext } from "../app-context-provider";
// import { buttonStyle, ColorType } from "../helpers/style-helpers";
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { motion } from 'framer-motion';
// import LoadingSpinner from '../components/loading-spinner';
export default function TopMenu({ pages, color }) {
  // const appContext = useContext(AppContext);
  return (
    <ul className='top-menu'>
      {pages?.map(
        (page, index) => (
          // document.getElementById(generateSectionId(page)) ? (

          <>
            <motion.li
              key={page.key}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}>
              <AnchorLink href={'#' + generateSectionId(page)} key={page.key}>
                {page.title}
              </AnchorLink>
            </motion.li>
            {/* {document.getElementById(generateSectionId(page)) !==null ? (
              <motion.li
                key={page.key}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}>
                <AnchorLink href={'#' + generateSectionId(page)} key={page.key}>
                  {page.title}
                </AnchorLink>
              </motion.li>
            ) : (
              <LoadingSpinner />
            )} */}
          </>
        )
        //)
        // : (
        //     index === 0 && (
        //         <React.Fragment key={page.key}>
        //             <div style={{ filter: "invert(1)" }}>
        //                 <LoadingSpinner />
        //             </div>
        //             <h4 style={{ color: "white" }}>
        //                 Laster inn kategorier
        //             </h4>
        //         </React.Fragment>
        //     )
        // )
      )}
    </ul>
  );
}
